import { render, staticRenderFns } from "./BaseDelivery.vue?vue&type=template&id=c2a15d96&"
import script from "./BaseDelivery.vue?vue&type=script&lang=js&"
export * from "./BaseDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports